import {h} from 'vue';
export default {
  name: 'ValidationGroup',
  provide() {
    return {
      validationGroup: this,
    };
  },
  emits: ['submit'],
  props: {
    alwaysSubmit: { type: Boolean, default: false },
  },
  data: () => ({
    valid: true,
    submitted: false,
    touched: false,
    fields: [],
    validityWatchers: [],
  }),
  computed: {
    state() {
      return {
        valid: this.valid,
        submitted: this.submitted,
        touched: this.touched,
      };
    },
  },
  methods: {
    preventAndSubmit(event) {
      event.preventDefault();
      this.submit();
    },
    submit() {
      this.touch();
      this.submitted = true;
      this.valid = this.$refs.form.checkValidity();

      if (this.alwaysSubmit || this.valid) {
        this.$emit('submit', this.state);
      }
    },
    touch() {
      this.touched = true;
      this.fields.forEach((field) => {
        field.touched = true;
      });
    },
    updateLater() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        void this.$nextTick(this.update);
      }, 100);
    },
    update() {
      this.valid = this.fields.every((field) => field.valid);
      this.touched = this.fields.some((field) => field.touched);
    },
    reset() {
      this.valid = true;
      this.touched = false;
      this.submitted = false;
      this.fields.forEach((field) => field.reset());
    },
    add(field) {
      this.fields.push(field);
      this.validityWatchers.push(this.$watch(
        () => field.valid,
        this.updateLater,
        { immediate: true },
      ));
    },
    remove(field) {
      const index = this.fields.indexOf(field);

      if (index !== -1) {
        this.fields.splice(index, 1);
        this.validityWatchers[index]();
        this.validityWatchers.splice(index, 1);
        this.updateLater();
      }
    },
  },
  render() {
    const children = this.$slots?.default
      ? this.$slots?.default(this.state)
      : this.$slots?.default;

    return h('form', {
      ref: 'form',
      novalidate: true,
      onSubmit: this.preventAndSubmit,
    }, children);
  },
};
